import React, { useEffect, useRef } from 'react';
import { Modal } from 'bootstrap';

const ConfirmModal = ({ message, title, confirmLabel, cancelLabel, confirmCallback, cancelCallback }: Props) => {
  const modalRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    modalRef.current && new Modal(modalRef.current, { backdrop: 'static' });
  }, []);

  useEffect(() => {
    if(modalRef.current) {
      const instance = Modal.getInstance(modalRef.current);
      if(message && message.length) {
        instance && instance.show();
      }
      else {
        instance && instance.hide();
      }
    }
  }, [ message ]);

  return (
    <div ref={modalRef} className="modal fade" data-bs-backdrop="static" tabIndex={-1}>
        <div className="modal-dialog modal-sm">
          <div className="modal-content bg-white">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{title}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={cancelCallback}></button>
            </div>
            <div className="modal-body">
              {
                message && message.map(m => (
                  <p key={m} className="d-block text-center text-dark">{m}</p>
                ))
              }
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary btn-sm" data-bs-dismiss="modal" onClick={confirmCallback}>{confirmLabel}</button>
              <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal" onClick={cancelCallback}>{cancelLabel}</button>
            </div>
          </div>
        </div>
      </div>
  );
}

interface Props {
  message: string[],
  title: string,
  confirmLabel: string,
  cancelLabel: string,
  confirmCallback: () => void,
  cancelCallback: () => void
}

export { ConfirmModal };